export default {
  Journal: '#ffeab6',
  Preprint: '#d1e2ff',
}
